import TodaysOrdersWidget from "@/components/TodaysOrdersWidget";
import MyTasksWidget from "@/components/MyTasksWidget";
import MyApplicationsWidget from "@/components/MyApplicationsWidget";
import DepartmentQueuesWidget from "@/components/DepartmentQueuesWidget";
import AccountsReceivableQueueWidget from "@/components/ARTasksWidget";
import OwnerSummaryWidget from "@/components/OwnerSummaryWidget";
import QuickNotesWidget from "@/components/QuickNotesWidget";
import { useDashboardBus } from "@/lib/dashboardBus";

/**
 * Dashboard Widget Registry — single client-side source of truth for which
 * widget key renders which React component. Kept intentionally flat: no
 * conditional role logic here — visibility is decided by the backend
 * (`GET /api/dashboard/widgets`).
 *
 * Adding a widget:
 *   1. Add its key to `backend/dashboard_permissions.py` with the roles it's
 *      visible to and a slot ("hero" | "row-1" | "row-2" | "footer").
 *   2. Import the component below and register it against the same key.
 */

// Thin shells wire cross-widget state (e.g. task-refresh bumps) so the
// underlying widgets stay decoupled from the dashboard bus.
function MyTasksWidgetShell() {
  const bus = useDashboardBus();
  return <MyTasksWidget onTaskCreated={bus.bumpTaskRefresh} />;
}

function DepartmentQueuesWidgetShell() {
  const bus = useDashboardBus();
  return <DepartmentQueuesWidget refreshKey={bus.taskRefreshKey} />;
}

export const DASHBOARD_WIDGET_REGISTRY = {
  todays_orders:     TodaysOrdersWidget,
  my_tasks:          MyTasksWidgetShell,
  my_applications:   MyApplicationsWidget,
  quick_notes:       QuickNotesWidget,
  department_queues: DepartmentQueuesWidgetShell,
  ar_queue:          AccountsReceivableQueueWidget,
  owner_summary:     OwnerSummaryWidget,
};

// Render order of slots (top → bottom). Widgets within a slot keep the order
// returned by the backend.
export const DASHBOARD_SLOT_ORDER = ["hero", "row-1", "row-2", "row-3", "footer"];
